import type { ReactNode } from 'react'
import { useCourseTracking } from '../hooks/use-course-tracking'

// TODO: investigate
export default function CourseTracker(): ReactNode {
  useCourseTracking()
  return <></>
}
